<template>
  <GcBaseLayout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
    :backButtonEnable="false"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Sales Orders" :screenName="getScreenName" />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :gridOptions="gridOptions"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
        :rowClickCallBack="rowClickCallBack"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
// import CustomerTabsMixin from "@/_mixins/customer-tabs.mixin";
import GcDataGridReport from "@/components/gc-data-grid-report";
import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";
import { CommonStorage } from "../../_services/storage";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "sales-order-profit-enquiry-list",
      report: {
        title: "",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridOptions: {
        noDataMessage: {
          addNew: {
            class: "no-data",
            title: "Uh-oh!",
            message:
              "We are struggling to find what you are looking for. Try altering your search criteria",
          },
        },
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },
      tabs: SalesOrderTabs,
    };
  },
  computed: {
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      config.filter = undefined;
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
    getScreenName() {
      return "Sales Orders Profit Enquiry";
    },
  },

  async created() {
    CommonStorage.clear("go_back_route");
    this.selectedIndex = GetIndexByTabName("Enquiry");
    let response = await ScreenLayoutService.getByRoute(
      "sales-order-profit-enquiry-list"
    );
    if (response.data.value) {
      this.report = JSON.parse(response.data.value[0].Definition);
    }
  },
  methods: {
    rowClickCallBack(e) {
      if (e.rowType == "header") return;
      let salesOrder = e.row.data.SalesOrderCode;
      this.$router.push({
        path: `/sales-order-profit-enquiry/${salesOrder}`,
        query: e.row.data,
      });
    },
  },
};
</script>
